import React, { useEffect, useState } from "react";
import * as notify from "../../../shared/notify";
import eventEmitter from "../../../shared/events";

import { getNotes, sendNote } from "../lib/data";
import { sortNotes, hasSpecificNotes } from "../lib/helpers";
import { NotesProvider } from "./index";

const Notes = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [notes, setNotes] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const response = await getNotes({
                clientCode: props.clientCode,
                binTrackingNumber: props.binTrackingNumber,
                ...props.settings,
            });

            if (!response) {
                return;
            }

            var notesList = sortNotes(response);

            if (notesList && notesList.length > 0) {
                notesList.push(
                    notesList.splice(
                        notesList.findIndex((v) => v.noteType === "File"),
                        1
                    )[0]
                );
            }

            setNotes(notesList);
            setIsLoaded(true);

            if (hasSpecificNotes(response, props.taskType)) {
                eventEmitter.emit("TOGGLE_NOTES");
            }
        }

        fetchData();

        eventEmitter.on("REFRESH_NOTES", fetchData);

        return () => {
            eventEmitter.removeListener("REFRESH_NOTES", fetchData);
        };
    }, []);

    const addNotes = (value) => {
        return new Promise(async (resolve) => {
            if (!value) {
                notify.error("Please enter a note");
                resolve(false);
            }

            const payload = {
                items: [
                    {
                        ...props.settings,
                        noteText: value,
                        noteType: props.noteType,
                        taskType: props.taskType,
                    },
                ],
            };
            const response = await sendNote(payload, props.sourcePage);

            if (!response) {
                resolve(false);
            }

            var notesList = sortNotes([...notes, ...response]);

            if (notesList) {
                notesList.push(
                    notesList.splice(
                        notesList.findIndex((v) => v.noteType === "File"),
                        1
                    )[0]
                );
            }

            setNotes(notesList);

            resolve(true);
        });
    };

    if (!isLoaded) {
        return null;
    }

    return <NotesProvider value={{ addNotes, notes }}>{props.children}</NotesProvider>;
};

export default Notes;
